import { gql } from '@apollo/client'

const GET_INSURANCE_COMPANY_DHS_HIERARCHY = gql`
  query getInsuranceCompanyDhsInsuranceHierarchy($input: GetDhsInsuranceHierarchyInput!) {
    getInsuranceCompanyDhsInsuranceHierarchy(input: $input) {
      success
      message
      data {
        id
        name
        insuranceLimit
        insurancePercentage
        insuranceUnlimited
        approvalRequired
        insuranceStartMonth
        forcePolicySelect
        policies {
          id
          policyNumber
          holderName
          coverageType
          status
          due
          inception
          classes {
            id
            name
            maxLimit
            insuranceLimit
            insuranceUnlimited
            insurancePercentage
            approvalRequired
          }
        }
      }
    }
  }
`

export default GET_INSURANCE_COMPANY_DHS_HIERARCHY
